import React, { useContext, useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import phoneTypes from "../../data/phoneTypes";
import relationshipList from "../../data/relationshipList";
import "../../scss/pages/admin/_leloregistration.scss";
import { useNavigate, useLocation } from "react-router-dom";
import leloContext from "../../context/leloreg/leloContext";
import { toast } from "react-toastify";

const R3ParentInformation = () => {
  const {
    formData,
    onFormDataChange,
    pass: { parent },
  } = useContext(leloContext);
  const navigate = useNavigate();
  const [FormSubmit, setFormSubmit] = useState(false); // Track if form submission attempted
  const location = useLocation();
  const { _uuid, age, ages, permalink, LeloRegistrationProfile, _id } = location.state || {};
  
  const filteredRelationshipList = 
    _uuid === undefined 
      ? (age < 18 ? relationshipList.filter((item) => item !== "Self 18+") : relationshipList)
      : (ages < 18 ? relationshipList.filter((item) => item !== "Self 18+") : relationshipList);

  const {
    firstName,
    pgFirstName,
    pgLastName,
    pgRelationshipToStudent,
    pgPrimaryEmail,
    pgPrimaryPhone,
    pgPrimaryPhoneType,
    charter,
    charter_id,
  } = formData;

  useEffect(() => {
    if (!charter_id) {
      toast.error("Something went wrong");

      if (_uuid === undefined) {
        navigate(`/forms/${permalink}`);
      } else {
        navigate(`/forms/${permalink}/${_uuid}`);
      }
    }
  }, [charter_id, navigate, permalink, LeloRegistrationProfile, _id, _uuid]);
  
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Changes you made may not be saved.";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);  

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "pgPrimaryEmail") {
      onFormDataChange({
        target: {
          name,
          value: value.toLowerCase(),
        },
      });
    } else {
      onFormDataChange({
        target: {
          name,
          value: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
        },
      });
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (number) => /^\d{3}-\d{3}-\d{4}$/.test(number);

  const formatPhoneNumber = (e) => {
    let formattedValue = e.target.value.replace(/\D/g, "");
    if (formattedValue.length > 6) {
      formattedValue = `${formattedValue.slice(0, 3)}-${formattedValue.slice(
        3,
        6
      )}-${formattedValue.slice(6)}`;
    } else if (formattedValue.length > 3) {
      formattedValue = `${formattedValue.slice(0, 3)}-${formattedValue.slice(
        3
      )}`;
    }

    onFormDataChange({
      target: { name: "pgPrimaryPhone", value: formattedValue },
    });
  };

  const parentFilledOut =
    pgRelationshipToStudent === "Self 18+"
      ? pgRelationshipToStudent
      : pgRelationshipToStudent &&
        pgFirstName &&
        pgLastName &&
        pgPrimaryEmail &&
        validateEmail(pgPrimaryEmail) &&
        pgPrimaryPhone &&
        validatePhone(pgPrimaryPhone) &&
        pgPrimaryPhoneType;

  const handleSubmit = () => {
    setFormSubmit(true); // Mark the form as submit
    if (parentFilledOut) {
      navigate("/leloStudent2", { state: { permalink, _uuid, pgRelationshipToStudent, _id, LeloRegistrationProfile } });
    }
  };

  // Helper function to get CSS class for form validation
  const getInputClassName = (value) => {
    if (FormSubmit && !value) {
      return "form-field-error";
    }
    return "form-field-default";
  };

  return (
    <>
      <div className="sub-form">
        <h2>
          Parent or Guardian Information<span>(3/7)</span>
          <hr />
        </h2>
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is the {pgFirstName || "Parent/ Guardian"}'s Relationship to{" "}
              {firstName || "the Student"}?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="pgRelationshipToStudent"
            value={pgRelationshipToStudent}
            onChange={handleChange}
            className={getInputClassName(pgRelationshipToStudent)}>
            <option value="">Please Select</option>
            {filteredRelationshipList.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        {pgRelationshipToStudent !== "Self 18+" && (
          <>
            <div className="item">
              <div className="asterisk-group">
                <h3>What is the Parent/ Guardian's First Name?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="pgFirstName"
                maxLength="50"
                value={pgFirstName}
                onChange={handleChange}
                className={getInputClassName(pgFirstName)}
              />
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>What is the {pgFirstName || "Parent/ Guardian"}'s Last Name?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="pgLastName"
                maxLength="50"
                value={pgLastName}
                onChange={handleChange}
                className={getInputClassName(pgLastName)}
              />
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>What is the {pgFirstName || "Parent/ Guardian"}'s Email?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="email"
                name="pgPrimaryEmail"
                value={pgPrimaryEmail}
                onChange={handleChange}
                className={getInputClassName(pgPrimaryEmail)}
              />
              {pgPrimaryEmail && !validateEmail(pgPrimaryEmail) && (
                <p className="validEmail">Please provide a valid email address</p>
              )}
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>What is the {pgFirstName || "Parent/ Guardian"}'s Primary Phone Number?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                placeholder="XXX-XXX-XXXX"
                name="pgPrimaryPhone"
                maxLength={12}
                value={pgPrimaryPhone}
                onChange={formatPhoneNumber}
                className={getInputClassName(pgPrimaryPhone)}
              />
              {pgPrimaryPhone && !validatePhone(pgPrimaryPhone) && (
                <p className="validEmail">
                  Please provide a valid phone number in the following format
                  XXX-XXX-XXXX
                </p>
              )}
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>What is the {pgFirstName || "Parent/ Guardian"}'s Primary Phone Type?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="pgPrimaryPhoneType"
                value={pgPrimaryPhoneType}
                onChange={handleChange}
                className={getInputClassName(pgPrimaryPhoneType)}>
                <option value="">Please Select</option>
                {phoneTypes.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}

        {/* Progress Buttons */}
        <div className="progress-btns">
          <div className="circle-btn" onClick={() => navigate(-1)}>
            <FaIcons.FaChevronLeft
              className="progress-level-btn"
              onClick={() => navigate(-1)}
            />
          </div>

          <div className="circle-btn" onClick={handleSubmit}>
            <FaIcons.FaChevronRight
              className="progress-level-btn"
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default R3ParentInformation;